/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    /**
     * Factory callback type
     */
    declare type DocumentEventsDirectiveFactoryCb = ($rootScope: ng.IRootScopeService,
                                                     $window: ng.IWindowService,
                                                     $timeout: ng.ITimeoutService,
                                                     $document: ng.IDocumentService,
                                                     miniSidebarService: Services.MiniSidebarService) => DocumentEventsDirective;

    /**
     * Custom scope
     */
    export interface IDocumentEventsDirectiveScope extends ng.IScope {
        submenuToggle: ($event: IExtendedEvent) => void;
    }

    interface IExtendedEvent extends ng.IAngularEvent {
        currentTarget: Object;
    }

    export class DocumentEventsDirective implements ng.IDirective {
        public static $name: string = 'documentEvents';

        public link: ($scope: ng.IScope, $element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'A';

        /**
         * Factory for the directive
         */
        public static Factory(): DocumentEventsDirectiveFactoryCb {
            let directive: DocumentEventsDirectiveFactoryCb = ($rootScope: IFlexRootScope,
                                                               $window: ng.IWindowService,
                                                               $timeout: ng.ITimeoutService,
                                                               $document: ng.IDocumentService,
                                                               miniSidebarService: Services.MiniSidebarService) => {
                return new DocumentEventsDirective($rootScope, $window, $timeout, $document, miniSidebarService);
            };
            directive.$inject = ['$rootScope', '$window', '$timeout', '$document', 'miniSidebarService'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor($rootScope: IFlexRootScope,
                    $window: ng.IWindowService,
                    $timeout: ng.ITimeoutService,
                    $document: ng.IDocumentService,
                    miniSidebarService: Services.MiniSidebarService) {

            DocumentEventsDirective.prototype.link = ($scope: IDocumentEventsDirectiveScope, $element: JQuery, attrs: ng.IAttributes) => {
                let hidePrimarySidebar: () => void = (): void => {
                    $rootScope.primarySidebarActive = false;
                    $rootScope.primarySidebarOpen = false;
                    $rootScope.primarySidebarHiding = true;
                    $timeout(() => {
                        $rootScope.primarySidebarHiding = false;
                    }, 280);
                };

                let hideSecondarySidebar: () => void = (): void => {
                    $timeout(() => {
                        $rootScope.secondarySidebarActive = false;
                    });
                };

                let hideAlarmConsole: () => void = (): void => {
                    $timeout(() => { 
                        $rootScope.alarmConsoleHidden = true;
                        $rootScope.$broadcast('consoleHidden', undefined);
                    }); 
                };

                // hide components on $document click
                $document.on('click', ($event: JQueryKeyEventObject): void => {
                    // mini sidebar
                    if (!$rootScope.miniSidebarActive && !$rootScope.largeScreen && !$($event.target).closest('#sidebar_main').length) {
                        miniSidebarService.toggleSidebarMini(true);
                    }

                    // secondary sidebar
                    if ($rootScope.secondarySidebarActive && !$($event.target).closest('#sidebar_secondary').length &&
                        !$($event.target).closest('#sSwitch_secondary').length) {
                        hideSecondarySidebar();
                    }
                    // alarms console 
                    if (!$rootScope.alarmConsoleHidden && !$($event.target).closest('.alarms_console_container').length &&
                        $('#monitors-container').length === 0 && !$rootScope.alarmConsoleSticky) {
                        hideAlarmConsole();
                    }
                });

                // hide components on esc key press
                $document.on('keyup', ($event: JQueryKeyEventObject) => {
                    // primary sidebar
                    if ($rootScope.primarySidebarActive && !$rootScope.largeScreen && $event.keyCode === 27) {
                        hidePrimarySidebar();
                    }
                    // secondary sidebar
                    if ($rootScope.secondarySidebarActive && $event.keyCode === 27) {
                        hideSecondarySidebar();
                    }
                    // alarms console 
                    if ($rootScope.alarmConsoleHidden === false && $event.keyCode === 27 &&
                        $('#monitors-container').length === 0 && !$rootScope.alarmConsoleSticky) {
                        hideAlarmConsole();
                    }
                });

                let w: JQuery = angular.element($window);
                $rootScope.largeScreen = w.width() >= 1255;

                w.on('resize', () => {
                    $timeout(() => {
                        let largeScreen: boolean = w.width() >= 1255;
                        $rootScope.$broadcast('windowWidth', largeScreen);
                        $rootScope.$broadcast('windowHeight', w.height());
                    });
                });

                $scope.$on('$destroy', () => {
                    $document.off('click');
                    $document.off('keyup');
                    // w.off('resize');
                });
            };
        };
    }
}